import styles from './KpiCard.module.css';

interface KpiCardProps {
  label: string;
  value: string;
  delta: string;
  trend: 'up' | 'down' | 'flat';
}

export function KpiCard({ label, value, delta, trend }: KpiCardProps) {
  return (
    <div className={styles.kpi}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
      <div className={`${styles.delta} ${styles[trend]}`}>{delta}</div>
    </div>
  );
}
